/**
 * BarcodeScanner utility class
 * Listens for rapid keystrokes from barcode scanners and triggers callback with scanned value
 */
class BarcodeScanner {
  constructor(onScan, options = {}) {
    this.onScan = onScan;
    this.buffer = '';
    this.lastKeyTime = 0;
    this.threshold = options.threshold || 150; // ms between keystrokes (increased for gun scanners)
    this.minLength = options.minLength || 4;  // minimum barcode length
    this.submitDelay = options.submitDelay || 200; // ms to wait after last keystroke before auto-submit
    this.timeout = null;
    this.enabled = true;

    this.handleKeyDown = this.handleKeyDown.bind(this);
    document.addEventListener('keydown', this.handleKeyDown);
  }

  handleKeyDown(e) {
    if (!this.enabled) return;

    // Skip if user is typing in an input field
    const activeElement = document.activeElement;
    const isInputField = activeElement && (
      activeElement.tagName === 'INPUT' ||
      activeElement.tagName === 'TEXTAREA' ||
      activeElement.isContentEditable
    );

    // Allow scanning even in input fields if it's rapid input (scanner behavior)
    const now = Date.now();
    const timeDiff = now - this.lastKeyTime;

    // Reset buffer if too much time passed (human typing)
    if (timeDiff > this.threshold && this.buffer.length < this.minLength) {
      this.buffer = '';
    }

    // Enter key = end of scan
    if (e.key === 'Enter') {
      if (this.buffer.length >= this.minLength) {
        e.preventDefault();
        e.stopPropagation();
        this.onScan(this.buffer);
      }
      this.buffer = '';
      return;
    }

    // Only capture printable characters
    if (e.key.length === 1) {
      // If typing slowly in input field, don't capture
      if (isInputField && timeDiff > this.threshold) {
        this.buffer = '';
        return;
      }

      this.buffer += e.key;
      this.lastKeyTime = now;

      // Auto-submit after brief pause (some scanners don't send Enter)
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        if (this.buffer.length >= this.minLength) {
          this.onScan(this.buffer);
        }
        this.buffer = '';
      }, this.submitDelay);
    }
  }

  enable() {
    this.enabled = true;
  }

  disable() {
    this.enabled = false;
    this.buffer = '';
  }

  destroy() {
    document.removeEventListener('keydown', this.handleKeyDown);
    clearTimeout(this.timeout);
  }
}

export default BarcodeScanner;
